<template>
  <v-flex xs12 sm12 d-block class="card-dados card-dados__mobile" style="border: .08em solid #eee">
    <p id="tituloPainel" class="card-dados__titulo mb-0" style="font-weight: 600; color: #777; background-color: #cfcfcf; padding: 0.6rem 0.8rem;">Listagem</p>

    <v-data-table :headers="headersTabela" :items="value" hide-actions
                  class="az-text az-table-list tabela-itens"
                  :custom-sort="ordenarPorIdentificacaoSequencial">
      <template slot="items" slot-scope="props">
        <td>
          {{ props.item.identificacaoSequencial }}
        </td>
        <td ref="coluna_descricao">
          <expansao-texto :tamanho="tamanho" :texto="props.item.descricao"/>
        </td>
        <td>
          {{ props.item.situacao | azEnum(situacoesItensELotes) }}
        </td>
        <td>
          {{ props.item.porteExclusivo ? 'Sim' : 'Não' }}
        </td>
        <td align="right">
          {{ props.item.unidade }}
        </td>
        <td align="right">
          {{ props.item.quantidade | cdCurrency('', qtdeCasasDecimais(casasDecimaisQuantidade)) }}
        </td>
        <td v-if="exibeValorReferencia && possuiValorReferencia" align="right">
          {{ props.item.valorEstimado | cdCurrency(prefix, casasDecimais) }}{{suffix}}
        </td>
      </template>
    </v-data-table>
  </v-flex>
</template>

<script>
import {mapState} from 'vuex'
import qtdeCasasDecimais from '@/views/mixins/qtdeCasasDecimais'
import sort from '@/views/mixins/sort'

export default {
    name: 'PainelItemVisualizacao',
    mixins: [sort, qtdeCasasDecimais],
    props: {
        value: {
            required: true,
            type: Array,
            default: () => {
                return []
            }
        },
        possuiValorReferencia: {
            type: Boolean,
        },
        exibeValorReferencia: {
            type: Boolean,
        },
        casasDecimais: {
            type: Number,
            default: 2
        },
        prefixOuSuffixValor:{
            type: String
        },
        criterioJulgamento:{
            type: String
        },
        isCriterioJulgamentoMaiorDesconto:{
            type: Boolean,
            default: false
        },
        casasDecimaisQuantidade: {
            type: Number,
            default: 2
        }
    },
    data() {
        return {
            tamanho: null,
            situacoesItensELotes: {
                ADJUDICADO: 'Adjudicado',
                AGUARDANDO_ANALISE: 'Aguardando Análise',
                CLASSIFICADO: 'Classificado',
                ANULADO: 'Anulado',
                CANCELADO: 'Cancelado',
                DESERTO: 'Deserto',
                EM_ANDAMENTO: 'Em Andamento',
                EM_ELABORACAO: 'Em Elaboração',
                FRACASSADO: 'Fracassado',
                REVOGADO: 'Revogado'
            }
        }
    },
    computed: {
        ...mapState(['loki']),
        total() {
            let total = 0
            this.value.forEach(item => {
                if (item.totalEstimado > 0) {
                    total += item.totalEstimado
                }
            })
            return total
        },
        prefix(){
            return this.prefixOuSuffixValor === 'R$' ? 'R$ ' : ''
        },
        suffix(){
            return this.prefixOuSuffixValor === '%' ? '%' : ''
        },
        headersTabela(){
            return [
                {
                    text: 'Seq',
                    sortable: true,
                    align: 'left',
                    width: '5%',
                    class: 'primary--text',
                    value: 'sequencia'
                },
                {
                    align: 'left',
                    text: 'Descrição',
                    value: 'descricao',
                    width: '30%',
                    class: 'primary--text',
                    sortable: false
                },
                {
                    text: 'Situação',
                    sortable: false,
                    value: 'situacao',
                    align: 'left',
                    width: '10%',
                    class: 'primary--text'
                },
                {
                    text: 'Exclusivo',
                    sortable: false,
                    width: '5%',
                    align: 'left',
                    class: 'primary--text'
                },
                {
                    text: 'Unidade',
                    value: 'unidade',
                    sortable: false,
                    align: 'right',
                    width: '8%',
                    class: 'primary--text'
                },
                {
                    text: 'Qtd',
                    value: 'quantidade',
                    sortable: false,
                    align: 'right',
                    width: '5%',
                    class: 'primary--text'
                },
                ... this.exibeValorReferencia && this.possuiValorReferencia ? [{
                    value: 'valorEstimado',
                    text:  this.isCriterioJulgamentoMaiorDesconto ? 'Estimado Unit. (%)' : 'Estimado Unit. (R$)',
                    sortable: false,
                    align: 'right',
                    width: '10%',
                    class: 'primary--text'
                }] : [],
            ]
        }
    },
    created() {
        window.addEventListener('resize', this.pegarTamanho)
        this.pegarTamanho()
    },
    destroyed() {
        window.removeEventListener('resize', this.pegarTamanho)
    },
    methods: {
        pegarTamanho() {
            this.tamanho = 0.082 * window.innerWidth
        }
    }
}
</script>

<style scoped>
.tabela-itens, .tabela-itens-manual {
    padding: 16px;
}

@media (max-width: 720px) {
    .tabela-itens, .tabela-itens-manual {
        padding: 0;
    }
}
</style>
